import React, {useCallback} from 'react'
import {Image, Button, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'
import {getUrl} from '../../utils/cloudinary-utils'
import {useStoreContext} from '../../contexts/store'
import {useSiteContext} from '../../contexts/site'
import useTagManager from '../../hooks/use-tag-manager'
import {scheduleIdleAnalytics} from '../../utils/common-utils'

const FindStore = () => {
    const intl = useIntl()
    const {store, onOpen, isLoading} = useStoreContext()
    const {isYR} = useSiteContext()
    const tagManager = useTagManager()

    const trackHeaderInteraction = useCallback(
        (action) => {
            scheduleIdleAnalytics(() => {
                tagManager.headerInteraction(action)
            })
        },
        [tagManager]
    )

    const onFindStoreClick = useCallback(
        (event) => {
            const clickedAction = event?.target
                ?.closest?.('[data-track-action]')
                ?.getAttribute('data-track-action')

            onOpen()

            trackHeaderInteraction(clickedAction || 'find a store')
        },
        [onOpen, trackHeaderInteraction]
    )

    return (
        <Button
            onClick={onFindStoreClick}
            isLoading={isLoading}
            className="utility-link store-locator-wrapper"
            variant="unstyled"
            display={{base: 'none', md: 'flex'}}
            align="center"
            p="7.5px 7px 7.5px 10px"
            m="7.5px 0 7.5px 0"
            borderRadius="5px"
            fontSize="12px"
            fontWeight="300"
            _hover={{bg: 'grayAlpha5'}}
        >
            <Image
                data-track-action="find my store search"
                className="store-locator-svg"
                width="16px"
                height="18px"
                src={
                    isYR
                        ? getUrl('UIImages/images/pin-white.svg')
                        : getUrl('UIImages/images/pin-black.svg')
                }
                alt="Store Locator"
                marginRight="10px"
            />
            <Text
                data-track-action="find a store"
                fontFamily="body"
                color={isYR ? 'white' : 'black'}
            >
                {store && store.name ? (
                    <Text as="span" textTransform="capitalize">
                        {store.name.toLowerCase()}
                    </Text>
                ) : (
                    intl.formatMessage({
                        id: 'find.a.store',
                        defaultMessage: 'Find a Store'
                    })
                )}
            </Text>
        </Button>
    )
}

export default FindStore
